/**
 * Answer Service
 * Handles all question answer-related API calls
 */
import apiService from './apiService';
import { apiRequest } from './apiInterceptor';

class AnswerService {
  /**
   * Submit an answer for a question in an exam session
   * @param {number} examSessionId - The ID of the exam session
   * @param {number} questionId - The ID of the question
   * @param {Object} answerData - The answer data to submit
   * @returns {Promise<Object>} - The response data
   */
  async submitAnswer(examSessionId, questionId, answerData) {
    return apiService.post(`/api/exam/${examSessionId}/question/${questionId}`, answerData);
  }

  /**
   * Get answer statistics for a question (if such endpoint is implemented in the backend)
   * @param {number} questionId - The ID of the question
   * @returns {Promise<Object>} - The statistics data
   */
  async getAnswerStats(questionId) {
    return apiService.get(`/api/answer/stats/${questionId}`);
  }

  /**
   * Get answers for a question using HATEOAS link
   * @param {string} answersLink - The HATEOAS link to fetch answers
   * @returns {Promise<Array>} - Array of answers
   */
  async getAnswersByHateoasLink(answersLink) {
    if (!answersLink) {
      console.error('No answers link provided');
      return [];
    }    try {
      // console.log(`Fetching answers using HATEOAS link: ${answersLink}`);
      const response = await apiRequest(answersLink);
      
      if (Array.isArray(response)) {
        return response;
      } else if (response && typeof response === 'object') {
        // Check for common wrapper formats
        for (const key of ['items', 'data', 'answers', 'results']) {
          if (Array.isArray(response[key])) {
            return response[key];
          }
        }
        
        // Check if response itself contains answer properties
        if ('answer' in response || 'text' in response || 'isCorrect' in response) {
          return [response];
        }
      }
      
      console.warn('Unexpected answer format:', response);
      return [];
    } catch (error) {      console.error('Error fetching answers:', error);
      return [];
    }
  }
}

const answerService = new AnswerService();
export default answerService;
